import { SVGProps, Ref, forwardRef } from 'react';

export const PinFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="m15.354 16.72-.288-2.019 4.858-4.857 1.803 1.803L23 10.374 13.623 1 12.35 2.272l1.803 1.803-4.858 4.857-2.02-.288a6.12 6.12 0 0 0-5.193 1.73L1 11.456l5.14 5.138-5.136 5.134L2.276 23l5.136-5.134 5.129 5.128 1.082-1.082a6.12 6.12 0 0 0 1.731-5.192"
            fill="currentColor"
        />
    </svg>
));
PinFilledSize24Glyph.displayName = 'PinFilledSize24Glyph';
